export const pageVisibleValue = () => {
  return {
    'pageVisible:value': !document.hidden || false
  };
};